var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.subsystemTreeModalData.source === _vm.SOURCES.SUBSYSTEM_TREE_DO)?_c('digital-output'):_vm._e(),(_vm.subsystemTreeModalData.source === _vm.SOURCES.SUBSYSTEM_TREE_VA)?_c('virtual-alarm'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }